export const SYNC = 'sync'
export const CHECK = 'check'
export const START = 'start'
export const FINISH = 'finish'
export const CONTINUE = 'continue'
export const SAVE_CONFIG = 'save_config'
